import { render } from "./ListagemConsultaNotaFiscal.vue?vue&type=template&id=2761fb88&scoped=true"
import script from "./ListagemConsultaNotaFiscal.vue?vue&type=script&lang=js"
export * from "./ListagemConsultaNotaFiscal.vue?vue&type=script&lang=js"

import "./ListagemConsultaNotaFiscal.vue?vue&type=style&index=0&id=2761fb88&scoped=true&lang=css"
import "./ListagemConsultaNotaFiscal.vue?vue&type=style&index=1&id=2761fb88&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2761fb88"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QIcon,QPopupProxy,QDate,QBtn,QTable,QTd,QPagination,QField});qInstall(script, 'directives', {ClosePopup});
